import React from "react";
import { LoginPage } from "../../components";

const Login = () => {
  return <LoginPage />;
};

export default Login;
